import { render, staticRenderFns } from "./dialogVega.vue?vue&type=template&id=0c15f484&scoped=true"
import script from "./dialogVega.vue?vue&type=script&lang=js"
export * from "./dialogVega.vue?vue&type=script&lang=js"
import style0 from "./dialogVega.vue?vue&type=style&index=0&id=0c15f484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15f484",
  null
  
)

export default component.exports